module.exports = __webpack_public_path__ + "static/media/beaconManageInventory.f9c85314.jpg";